<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
          Payment Methods
          <small>{{ title }}</small>
        </h1>
      <ol class="breadcrumb">
        <li>
          <router-link
            :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link
            :to="{path: '/payment/methods'}">
            Payment Methods
          </router-link>
        </li>
        <li class="active">
          <span>{{ title }}</span>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">
                {{ title }}
              </h3>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body">
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click.prevent="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="name"
                      name="name"
                      placeholder="Name"
                      v-model="form.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="key"
                    class="col-sm-2 control-label">
                    Key <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="key"
                      name="key"
                      placeholder="Key"
                      v-model="form.key">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Status
                  </label>

                  <div class="col-sm-10">
                    <label class="form-check-label">
                      <label for="disable">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="status"
                          id="disable"
                          value="0"
                          v-model="form.status"> Disabled
                      </label>
                      <label for="enable">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="status"
                          id="enable"
                          value="1"
                          v-model="form.status"> Enabled
                      </label>
                    </label>
                  </div>
                </div>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';

export default {
  mixins: [Common],

  data() {
    return {
      title: 'Create Payment Method',

      error: null,

      isCreate: false,

      form: {
        id: null,
        name: null,
        key: null,
        status: 1,
      },
    };
  },

  methods: {
    async fetch() {
      this.axios.get(`/payments/method/${this.$route.params.id}`)
        .then((response) => {
          this.form = response.data.data;
        });
    },

    validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.key) {
        this.$swal('Key required', 'Please fill key to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      const data = {
        name: this.form.name,
        key: this.form.key,
        status: this.form.status,
      };

      return this.axios.post('/payments/method', this.stringify(data))
        .then(() => {
          this.$router.push({
            path: '/payment-methods',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    update() {
      const data = {
        id: this.form.id,
        name: this.form.name,
        key: this.form.key,
        status: this.form.status,
      };

      return this.axios.put(`payments/method/${this.form.id}`, this.stringify(data))
        .then(() => {
          this.$router.push({
            path: '/payment-methods',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },
  },

  created() {
    if (this.$route.params.page === 'create') {
      this.isCreate = true;
    } else {
      this.title = 'Edit Payment Method';
      this.fetch();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/methods/Form.vue